import Menu from "./components/Menu";
import Footer from "./components/Footer";
import FloatingButtons from "./components/FloatingButtons";
import SEO from "./components/SEO";
import { Outlet } from "react-router-dom";

function App() {
  return (
    <div>
      <SEO />
      <FloatingButtons />
      <Menu />
      <main style={{ minHeight: "60vh" }}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default App;
